<template>
  <Icon :style="getStyle()" :component="SearchSvg" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import SearchSvg from './svg/SearchSvg.vue';

export default defineComponent({
  name: 'SearchIcon',
  components: {
    Icon
  },
  props: {
    isActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      SearchSvg: markRaw(SearchSvg)
    };
  },
  methods: {
    getStyle() {
      const s = {
        color: this.isActive ? 'white' : '#039',
      };

      return s;
    }
  }
});
</script>
